<template>
  <div class="container-fluid">
    <form ref="form" class="needs-validation" @submit.prevent="save">
      <div class="row">
        <div class="col-sm-4">
          <div v-if="permission.id" class="editable p-2">
            {{ permission.shareable.name }}
          </div>

          <div v-else-if="formData.shareableType === 'distributors'" class="form-group">
            <distributor-select
              v-model="formData.shareableId"
              v-validate="modelValidations.shareableId"
              :label="null"
              :for-select="true"
              name="shareableId"
              placeholder="Seleccione Distribuidor"
            />

            <small v-show="shareableId.invalid" class="text-danger">
              {{ getError('shareableId') }}
            </small>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <el-checkbox
              v-model="formData.read"
              border
              class="form-control"
              label="Lectura"
              name="read"
              :checked="formData.read"
            >
            </el-checkbox>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <el-checkbox
              v-model="formData.write"
              border
              class="form-control"
              label="Escritura"
              name="write"
              :checked="formData.write"
            >
            </el-checkbox>
          </div>
        </div>

        <div class="col-sm-2 text-center pt-2">
          <base-button native-type="submit" size="sm" type="success">
            <i class="fas fa-save"></i>
          </base-button>

          <base-button size="sm" type="danger" @click="$emit('cancel')">
            <i class="fas fa-ban"></i>
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DistributorSelect from '../../../components/ModelSelects/DistributorSelect';
import { Select, Option, Checkbox } from 'element-ui';
import { mapFields } from 'vee-validate';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    DistributorSelect,
  },

  props: {
    showSubtitle: {
      type: Boolean,
      default: true,
    },

    permission: {
      type: Object,
      default: () => {
        return {
          id: null,
          plotId: null,
          shareableId: null,
          shareableType: 'distributors',
          read: false,
          write: false,
        };
      },
    },
  },

  data() {
    return {
      formData: {
        id: this.permission.id,
        plotId: null,
        shareableId: this.permission.shareableId,
        shareableType: this.permission.shareableType,
        read: this.permission.read,
        write: this.permission.write,
      },

      modelValidations: {
        shareableId: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['shareableId']),
  },

  methods: {
    clean() {
      this.formData = {
        id: null,
        plotId: null,
        shareableId: null,
        shareableType: 'distributors',
        read: false,
        write: false,
      };
      this.$refs.form.reset();
      this.$validator.reset();
      this.errors.clear();
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.permission.id ? this.$emit('update', this.formData) : this.$emit('create', this.formData);
        }
      });
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}

.editable {
  font-weight: bold;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
</style>
